// src/components/skeleton/CommentDrawerSkeleton.js
import React from 'react';
import './CommentDrawerSkeleton.css';

export default function CommentDrawerSkeleton() {
  return (
    <div className="comment-skeleton-container">
      {[...Array(3)].map((_, i) => (
        <div key={i} className="comment-skeleton-item">
          <div className="comment-skeleton-avatar shimmer"></div>
          <div className="comment-skeleton-lines">
            <div className="comment-skeleton-line short shimmer"></div>
            <div className="comment-skeleton-line shimmer"></div>
          </div>
        </div>
      ))}
    </div>
  );
}
